export default __webpack_public_path__ + "static/media/arborlandscapewebsite.822c0370.jpg";